import * as React from "react";
import { Navigate } from "react-router";

export type ProtectedRouteProps = {
  authenticationPath: string;
  outlet: React.JSX.Element;
  allowedRole?: string;
};

export default function ProtectedRoute({
  authenticationPath,
  outlet,
  allowedRole,
}: ProtectedRouteProps) {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const isSalesPerson = localStorage.getItem("is_sales_person") === "true";
  const isRmUser = localStorage.getItem("is_rm_user") === "true";

  if (!isAuthenticated) {
    return <Navigate to={authenticationPath} replace />;
  }

  if (allowedRole === "sales" && !isSalesPerson) {
    return <Navigate to="/dashboard" replace />;
  }

  if (allowedRole === "rm" && !isRmUser) {
    return <Navigate to="/dashboard" replace />;
  }

  if (allowedRole === "admin" && isRmUser) {
    return <Navigate to="/rm" replace />;
  }

  if (allowedRole === "admin" && isSalesPerson) {
    return <Navigate to="/sales" replace />;
  }


  return outlet;
}
